// Tempo em milissegundos:
// 60_000 = 60 segundos = 1 minuto
// 10 * 60_000 = 600_000 = 10 minutos
export const LIST_STALE_TIME = 60_000;
export const LIST_CACHE_TIME = 10 * 60_000;
